import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Profile } from '@model/profile.model';
import { User } from '@model/user.model';
import { AuthService } from '@security/services/auth.service';
import { LoginService } from '@security/services/login.service';
import { LanguagesService } from '@shared/services/languages.service';
import { UserService } from '@shared/services/user.service';
import { UtilsService } from '@shared/services/utils.service';
import { CommonService } from 'app/service/common.service';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-area-utente',
  templateUrl: './area-utente.component.html',
  styleUrls: ['./area-utente.component.scss'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class AreaUtenteComponent {

  user$: BehaviorSubject<User>;
  activeProfile$: BehaviorSubject<Profile>
  isRefreshed$: BehaviorSubject<boolean>;
  revertChevrot: boolean = false;
  profiles$: BehaviorSubject<any>;
  selectedLanguage$: BehaviorSubject<string>;
  languages: Array<string>;
  isLangaugesOpen: boolean;

  constructor(public commonService: CommonService,public auth: AuthService, private userService: UserService, private languagesService: LanguagesService,
    private loginService: LoginService, private router: Router, private utils: UtilsService, private location: Location) {
    
    this.user$ = this.userService.user$;
    this.activeProfile$ = this.userService.activeProfile$;
    this.profiles$ = this.userService.profiles$;
    this.isRefreshed$ = this.loginService.isRefreshed$;
    this.selectedLanguage$ = this.languagesService.selectedlanguage$;
    this.languages = this.languagesService.languages;
  }

  selectLanguage(language: string){
    this.languagesService.selectLanguage(language);
  }


  logOut() {
    this.loginService.logout();
  }

  changeProfile() {
    this.utils.openModal('confirm',
      {
        title: 'userArea.changeProfile',
        description: 'userArea.changeProfileDescription',
        accept: 'yes',
        reject: 'no',
        confirm: () => {
          this.userService.resetProfile();
          this.router.navigate(['access', 'choose-profile']);
        }
      })
  }

}
